<style lang="scss" src="./AccountList.scss"></style>
<template>
  <div class="">
    <div class="search">
      <h2>Lista de Caixas</h2>

      <form>
        <div class="input-group">
          <input type="text" class="form-control" v-model="searchForm.name" />

          <div class="input-group-btn">
            <button
              type="button"
              class="btn btn-sm btn-primary"
              @click="searchAccount"
            >
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="list">
      <table class="table table-hover table-mail">
        <thead class="table-head">
          <tr>
            <th>Nome</th>
            <th>Descrição</th>
            <th></th>
          </tr>
        </thead>

        <tbody class="table-list">
          <tr
            :class="{ unread: listItem.accountEnabled }"
            v-for="(listItem, listIdx) in accountingList.list"
            :key="listIdx"
          >
            <td>
              {{ listItem.name }}
            </td>
            <td>
              {{ listItem.description }}
            </td>

            <td class="list-command">
              <button
                class="btn btn-outline"
                @click="selectAccounting(listItem, listIdx)"
              >
                <i class="fa fa-edit text-success"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      accountingCashId: '',

      searchForm: {
        name: '',
      },
      accountingList: {
        originalList: [],
        list: [],
        control: {},
      },
    };
  },
  watch: {
    'searchForm.name'() {
      this.searchAccount();
    },
  },
  mounted() {
    this.listEmployeeAccount();
  },

  methods: {
    async listEmployeeAccount() {
      const accountingCahs = await this.$store.dispatch(
        'FINANCIAL-ACCOUNT/ListAll',
        { onlyEmployee: true },
      );
      this.accountingList.originalList = accountingCahs;
      this.searchAccount();
    },
    searchAccount() {
      const listFiltered = this.accountingList.originalList.filter((item) => {
        return (
          item.name.toUpperCase().indexOf(this.searchForm.name.toUpperCase()) >
          -1
        );
      });
      this.accountingList.list = listFiltered;
    },
    selectAccounting(account) {
      this.$emit('select-account', account);
    },
  },
};
</script>